"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsVB = void 0;
const pex_models_1 = require("@sphereon/pex-models");
const ajv_1 = __importDefault(require("ajv"));
const ajv_formats_1 = __importDefault(require("ajv-formats"));
const jsonpath_1 = __importDefault(require("jsonpath"));
const validationBundler_1 = require("./validationBundler");
class FieldsVB extends validationBundler_1.ValidationBundler {
    constructor(parentTag) {
        super(parentTag, 'fields');
        this.mustHaveValidJsonPathsMsg = 'field object "path" property must contain array of valid json paths';
        this.pathObjMustHaveValidJsonPathMsg = 'field object "path" property must contain valid json paths.';
        this.filterMustBeValidJsonSchemaMsg = 'field object "filter" property must be valid json schema';
        this.filterIsMustInPresenceOfPredicateMsg = 'field object must have a "filter" property if "predicate" is present';
        this.filterIsNotValidJsonSchemaDescriptorMsg = 'could not parse "filter" object as a valid json schema descriptor.';
        this.purposeShouldBeANonEmptyStringMsg = 'purpose should be a non empty string';
        this.shouldBeKnownOptionMsg = 'Unknown predicate property';
        this.schemaValidator = new ajv_1.default();
        (0, ajv_formats_1.default)(this.schemaValidator);
    }
    getValidations(fields) {
        let validations = [];
        if (fields) {
            for (let srInd = 0; srInd < fields.length; srInd++) {
                validations = [...validations, ...this.getValidationsFor(fields[srInd], srInd)];
            }
        }
        return validations;
    }
    getValidationsFor(field, indx) {
        return [
            {
                tag: this.getMyTag(indx),
                target: field,
                predicate: this.mustHaveValidJsonPaths(),
                message: this.mustHaveValidJsonPathsMsg,
            },
            {
                tag: this.getMyTag(indx),
                target: field,
                predicate: this.filterMustBeValidJsonSchema(),
                message: this.filterMustBeValidJsonSchemaMsg,
            },
            {
                tag: this.getMyTag(indx),
                target: field,
                predicate: this.filterIsMustInPresenceOfPredicate(),
                message: this.filterIsMustInPresenceOfPredicateMsg,
            },
            {
                tag: this.getMyTag(indx),
                target: field,
                predicate: (field) => FieldsVB.optionalNonEmptyString(field === null || field === void 0 ? void 0 : field.purpose),
                message: this.purposeShouldBeANonEmptyStringMsg,
            },
            {
                tag: this.getMyTag(indx),
                target: field,
                predicate: (field) => FieldsVB.shouldBeKnownOption(field === null || field === void 0 ? void 0 : field.predicate),
                message: this.shouldBeKnownOptionMsg,
            },
        ];
    }
    getMyTag(srInd) {
        // TODO extract to make it generic
        return this.parentTag + '.' + this.myTag + '[' + srInd + ']';
    }
    mustHaveValidJsonPaths() {
        return (fieldObj) => fieldObj.path != null && fieldObj.path.length > 0 && this._validateJsonPaths(fieldObj.path);
    }
    _validateJsonPaths(jsonPath) {
        const invalidPaths = [];
        jsonPath.forEach((path) => {
            try {
                jsonpath_1.default.parse(path);
            }
            catch (err) {
                invalidPaths.push(path);
            }
        });
        if (invalidPaths.length > 0) {
            throw this.toChecked(this.pathObjMustHaveValidJsonPathMsg + ' Got: ' + JSON.stringify(invalidPaths));
        }
        return true;
    }
    filterMustBeValidJsonSchema() {
        return (fieldObj) => this._validateFilter(fieldObj.filter);
    }
    _validateFilter(filter) {
        if (filter == null) {
            return true;
        }
        try {
            this.schemaValidator.compile(filter);
        }
        catch (err) {
            throw this.toChecked(this.filterIsNotValidJsonSchemaDescriptorMsg + ' Got ' + JSON.stringify(filter));
        }
        return true;
    }
    filterIsMustInPresenceOfPredicate() {
        return (fieldObj) => !(fieldObj.predicate != null && fieldObj.filter == null);
    }
    static optionalNonEmptyString(str) {
        // TODO extract to generic utils or use something like lodash
        return str == null || str.length > 0;
    }
    static shouldBeKnownOption(option) {
        // TODO can be be extracted as a generic function
        return option == null || option == pex_models_1.Optionality.Required || option == pex_models_1.Optionality.Preferred;
    }
}
exports.FieldsVB = FieldsVB;
